import { MutationCache, QueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiError } from "./api-client";
import { showErrorNotification } from "../utils/notifications";

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.suppressGlobalError) return;
      if (err instanceof ApiError && err.code === "PAYLOAD_VALIDATION_ERROR")
        return;
      const backendMessage =
        err instanceof ApiError
          ? err.message
          : i18next.t("common.unknownError");
      const code =
        err instanceof ApiError && err.code !== "UNKNOWN_ERROR"
          ? err.code
          : null;
      showErrorNotification(
        code ? `${backendMessage} [${code}]` : backendMessage,
      );
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: true, // Refetch when user switches back to tab
    },
  },
});
